// Тексты в data-файлах хранятся с html-разметкой и неразрывными пробелами.
// Там, где нужен чистый текст — атрибуты alt, мета-теги — прогоняем их через
// plainText.
export const plainText = (value = '') =>
  String(value)
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&[a-z]+;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
